/** Which Stripe intent backs the Elements clientSecret on the update-payment page. */
export const INTENT_TYPES = {
  /** The past-due invoice's own PaymentIntent. */
  Payment: 'payment',
  Setup: 'setup',
} as const;

export type IntentType = (typeof INTENT_TYPES)[keyof typeof INTENT_TYPES];
